'use client';

import styled from 'styled-components';

interface RadioLabelProps {
  checked: boolean;
}

const RadioLabel = styled.label<RadioLabelProps>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
  padding: 8px 18px;
  border-radius: 100px;
  background-color: ${(props) => (props.checked ? '#8424EA' : '#F0F0F0')};

  color: ${(props) => (props.checked ? props.theme.rootColor.white : props.theme.rootColor.gray7B)};
  font-size: 14px;
  font-weight: ${(props) => (props.checked ? 700 : 600)};
  line-height: normal;
  text-align: center;
`;

const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const FilterRadioStyled = { RadioLabel, HiddenInput };

export default FilterRadioStyled;
